import { getMyGroups } from '@/api/groups';
import type { MyGroupsResponse } from '@/api/groups';
import { useApiQuery } from './useApiQuery';

const EMPTY: MyGroupsResponse = {
  memberOf: [],
  available: [],
  pendingRequests: [],
};

/** Loads the current user's group memberships, available groups, and open requests. */
export const useMyGroups = () => {
  const query = useApiQuery<MyGroupsResponse>({
    queryFn: (signal) => getMyGroups(signal),
    mockData: EMPTY,
  });

  return {
    groups: query.data ?? EMPTY,
    isLoading: query.isLoading,
    error: query.error,
    reload: query.reload,
  };
};
